import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { User, AuthTokens } from '../../../shared/utils/types';

interface AuthState {
  user: User | null;
  tokens: AuthTokens | null;
  tokenExpiration: number | null; // Timestamp in milliseconds when access token expires
  isAuthenticated: boolean;
  isLoading: boolean;
}

const initialState: AuthState = {
  user: null,
  tokens: null,
  tokenExpiration: null,
  isAuthenticated: false,
  isLoading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
      state.isLoading = false;
    },
    setTokens: (
      state,
      action: PayloadAction<{ tokens: AuthTokens; expiration: number } | null>
    ) => {
      if (action.payload) {
        state.tokens = action.payload.tokens;
        state.tokenExpiration = action.payload.expiration;
      } else {
        state.tokens = null;
        state.tokenExpiration = null;
      }
    },
    clearUser: state => {
      state.user = null;
      state.tokens = null;
      state.tokenExpiration = null;
      state.isAuthenticated = false;
      state.isLoading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, setTokens, clearUser, setLoading } = authSlice.actions;
export default authSlice.reducer;
